"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMemoizedDatePickerDate = void 0;
var _web = require("@react-hookz/web");
/**
 * If the date is the same as the previous date, return the previous date. Otherwise, return the new
 * date.
 */
const useMemoizedDatePickerDate = nextDate => {
  const memoizedDate = (0, _web.usePrevious)(nextDate) || null;
  // Initially, we'll immediately return the nextDate since the usePrevious hook returns undefined
  // on the first render.
  if (!memoizedDate) {
    return nextDate || null;
  }

  // If we have a nextDate and it's the same as the memoizedDate, return the memoizedDate.
  if (nextDate && datePickerDateIsEqual(memoizedDate, nextDate)) {
    return memoizedDate;
  }

  // If we get here, nextDate is a new date or is falsy.
  return nextDate || null;
};
exports.useMemoizedDatePickerDate = useMemoizedDatePickerDate;
const datePickerDateIsEqual = (a, b) => {
  return a.year === b.year && a.month === b.month && a.day === b.day;
};
//# sourceMappingURL=useMemoizedDatePickerDate.js.map